import { Component, OnInit } from '@angular/core';
import { DaoService } from '../servicos/dao.service';
import { ConfirmationService } from 'primeng/api';
import { NgxUiLoaderService } from 'ngx-ui-loader';

/**
 * Agenda de compromissos.
 *
 * Regra de performance deste componente: nada de getters e nada de chamadas de
 * funcao no template. Todo valor derivado (rotulos, classes, cores, atrasos de
 * animacao) e calculado uma unica vez em `decorar()` e gravado no proprio
 * objeto com prefixo "_". O template so le propriedades.
 *
 * Filtragem: 100% no banco. Cada mudanca de escopo, periodo, categoria ou busca
 * dispara `consultar()`, que devolve a lista ja filtrada e os contadores
 * facetados calculados em SQL. O cliente nao recorta colecao nenhuma.
 */
@Component({
  selector: 'app-agenda',
  templateUrl: './agenda.component.html',
  styleUrls: ['./agenda.component.css']
})
export class AgendaComponent implements OnInit {

  constructor(private dao: DaoService, private conf: ConfirmationService, private loader: NgxUiLoaderService) { }

  servidor = 'https://www.diviprev.mg.gov.br/controladores/controler2.php';

  // ---------------------------------------------------------------- constantes
  readonly MESES = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
  readonly MESES_CURTO = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN',
    'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];
  readonly SEMANA = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
  readonly SEMANA_CURTO = ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SÁB'];
  readonly SEMANA_MINI = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];

  readonly CORES_RAPIDAS = ['#8579c4', '#e0533d', '#2f8f6d', '#d99b1c', '#2b6cb0',
    '#c2508f', '#4a5568', '#0f9b8e'];
  readonly AVISOS_RAPIDOS = [1, 3, 7, 15, 30];
  readonly COR_SEM_CATEGORIA = '#9aa3b2';

  readonly EMOJIS = [
    { grupo: 'Trabalho', itens: ['📌', '📋', '📁', '💼', '🗓️', '⏰', '✅', '📝', '🖊️', '📊', '📈', '🖥️'] },
    { grupo: 'Financeiro', itens: ['💰', '💵', '💳', '🏦', '🧾', '📉', '💹', '🪙', '🧮', '💎', '🏷️', '📮'] },
    { grupo: 'Jurídico', itens: ['⚖️', '📜', '🏛️', '🔏', '📑', '🗳️', '🔎', '🛡️', '🗝️', '📕', '✒️', '🧷'] },
    { grupo: 'Saúde', itens: ['🏥', '💊', '🩺', '🦷', '🧬', '🫀', '🩹', '😷', '🧘', '🏃', '🥗', '💤'] },
    { grupo: 'Pessoal', itens: ['🏠', '👨‍👩‍👧', '🎂', '🎁', '❤️', '🐶', '🐱', '🌱', '🎓', '💍', '👕', '🛒'] },
    { grupo: 'Lazer', itens: ['✈️', '🏖️', '🎬', '🎵', '⚽', '🎮', '📚', '🍽️', '☕', '🎸', '🏕️', '🚴'] },
    { grupo: 'Alertas', itens: ['⚠️', '🔥', '🚨', '❗', '⭐', '🔔', '🎯', '🚩', '💡', '🧿', '⚡', '🕐'] },
    { grupo: 'Símbolos', itens: ['🔵', '🟢', '🟡', '🔴', '🟣', '🟠', '⚫', '⚪', '🔶', '🔷', '♦️', '✳️'] }
  ];

  // ---------------------------------------------------------------- estado base
  usuario: any = null;
  telaUsuario: any = { visivel: false, nome: '', senha: '' };

  categorias: any[] = [];
  mapaCategorias: any = {};
  visiveis: any[] = [];

  contaNova = false;
  carregou = false;
  atualizando = false;

  // ---------------------------------------------------------------- filtros
  escopo = 'radar';                       // 'radar' (dentro do aviso) | 'todos'
  fTempo: any = { atrasado: false, hoje: false, futuro: false };
  fCategorias: any = {};                  // id -> boolean ; 0 = sem categoria
  temFiltro = false;

  // busca: so existe no escopo "todos" e so vale quando acionada
  busca = '';
  buscaAtiva = '';

  cont: any = { atrasado: 0, hoje: 0, futuro: 0, radar: 0, todos: 0 };
  contCat: any = {};
  contSemCat = 0;
  rotuloVazio = '';
  detalheVazio = '';
  iconeVazio = '🗒️';

  /** Descarta respostas fora de ordem quando os filtros são clicados em sequência. */
  private seq = 0;

  // ---------------------------------------------------------------- dialogos
  evento: any = { visivel: false };
  previa: any = null;
  telaReaj: any = { visivel: false };
  telaCategorias: any = { visivel: false };
  formCat: any = { visivel: false };
  seletorEmoji: any = { visivel: false };

  estiloDialogo: any = { width: '94vw', maxWidth: '560px' };
  estiloDialogoLargo: any = { width: '94vw', maxWidth: '680px' };

  // ---------------------------------------------------------------- calendario
  calendario: any = { visivel: false, ano: 0, meses: [], vazio: false };
  diaAberto: any = null;
  private cacheAno: any = {};

  ngOnInit() {
    this.identidade();
  }

  // =========================================================================
  // ACESSO
  // =========================================================================

  identidade() {
    const v = localStorage.getItem('usuarioAgenda');
    if (!v) {
      this.telaUsuario = { visivel: true, nome: '', senha: '' };
      return;
    }
    this.usuario = JSON.parse(v);
    this.consultar(true);
  }

  entrar() {
    const nome = (this.telaUsuario.nome || '').trim();
    const senha = (this.telaUsuario.senha || '').trim();
    if (!nome) {
      this.dao.toast('e', 'Informe o seu usuário');
      return;
    }
    if (!senha) {
      this.dao.toast('e', 'Informe a sua senha');
      return;
    }
    const u: any = { nome: nome, senha: senha };
    localStorage.setItem('usuarioAgenda', JSON.stringify(u));
    this.usuario = u;
    this.telaUsuario = { visivel: false, nome: '', senha: '' };
    this.consultar(true);
  }

  logout() {
    localStorage.removeItem('usuarioAgenda');
    this.usuario = null;
    this.visiveis = [];
    this.categorias = [];
    this.mapaCategorias = {};
    this.cacheAno = {};
    this.carregou = false;
    this.contaNova = false;
    this.escopo = 'radar';
    this.fTempo = { atrasado: false, hoje: false, futuro: false };
    this.fCategorias = {};
    this.busca = '';
    this.buscaAtiva = '';
    this.temFiltro = false;
    this.calendario.visivel = false;
    this.telaUsuario = { visivel: true, nome: '', senha: '' };
  }

  private obterChave() {
    return this.hash(this.usuario.nome + '-' + this.usuario.senha);
  }

  private hash(palavra) {
    let hash = 0, i, chr;
    if (palavra.length === 0) { return hash; }
    for (i = 0; i < palavra.length; i++) {
      chr = palavra.charCodeAt(i);
      hash = ((hash << 5) - hash) + chr;
      hash |= 0;
    }
    return hash;
  }

  // =========================================================================
  // CARGA
  // =========================================================================

  /**
   * Única porta de entrada de dados da tela.
   * @param inicial primeira carga (ou pós-mutação): semeia categorias e
   *                recalcula o indicador de conta nova.
   */
  consultar(inicial: boolean) {
    const meu = ++this.seq;
    const dados = {
      chave: this.obterChave(),
      escopo: this.escopo,
      tempo: this.tempoSelecionado(),
      categorias: this.categoriasSelecionadas(),
      busca: this.buscaAtiva,
      inicial: inicial ? 'sim' : 'nao'
    };

    if (inicial) { this.loader.start(); } else { this.atualizando = true; }

    this.dao.submeterEm(dados, 'consultarAgenda', this.servidor).then(r => {
      if (inicial) { this.loader.stop(); }
      // resposta velha de um clique anterior: ignora
      if (meu !== this.seq) { return; }
      this.atualizando = false;
      this.carregou = true;

      this.categorias = (r && r['categorias']) ? r['categorias'] : [];
      this.indexarCategorias();

      if (inicial) {
        this.contaNova = !!(r && r['contaNova'] === 'sim');
        this.cacheAno = {};
      }

      this.cont = (r && r['cont']) ? r['cont'] : { atrasado: 0, hoje: 0, futuro: 0, radar: 0, todos: 0 };
      this.contCat = (r && r['contCat']) ? r['contCat'] : {};
      this.contSemCat = Number(this.contCat[0] || 0);

      this.visiveis = this.decorar((r && r['compromissos']) ? r['compromissos'] : []);
      this.definirVazio();
    }).catch(() => {
      if (inicial) { this.loader.stop(); }
      if (meu !== this.seq) { return; }
      this.atualizando = false;
      this.carregou = true;
      this.dao.toast('e', 'Não foi possível carregar a sua agenda. Verifique a conexão.');
    });
  }

  /** Serializa o eixo de período no formato que o SQL espera. */
  private tempoSelecionado() {
    const l = [];
    if (this.fTempo.atrasado) { l.push('atrasado'); }
    if (this.fTempo.hoje) { l.push('hoje'); }
    if (this.fTempo.futuro) { l.push('futuro'); }
    return l.join(',');
  }

  private categoriasSelecionadas() {
    const l = [];
    const ids = Object.keys(this.fCategorias);
    for (let i = 0; i < ids.length; i++) {
      if (this.fCategorias[ids[i]]) { l.push(ids[i]); }
    }
    return l.join(',');
  }

  private indexarCategorias() {
    const mapa: any = {};
    for (let i = 0; i < this.categorias.length; i++) {
      const c = this.categorias[i];
      c._contraste = this.contraste(c.cor);
      mapa[c.id] = c;
    }
    this.mapaCategorias = mapa;
  }

  /** Enriquece cada compromisso com tudo que o template precisa ler direto. */
  private decorar(lista: any[]) {
    const saida = [];
    for (let i = 0; i < lista.length; i++) {
      const c = this.decorarItem(lista[i]);
      // animação sequencial, com teto para não arrastar listas longas
      c._delay = (Math.min(i, 14) * 0.05).toFixed(2) + 's';
      saida.push(c);
    }
    return saida;
  }

  private decorarItem(c: any) {
    const dias = Number(c.dias);
    const iso = (c.dia + '').substring(0, 10);
    const partes = iso.split('-');
    const ano = Number(partes[0]);
    const mes = Number(partes[1]);
    const dia = Number(partes[2]);
    const semana = new Date(ano, mes - 1, dia).getDay();

    c._iso = iso;
    c._dia = dia < 10 ? '0' + dia : '' + dia;
    c._mesExt = this.MESES_CURTO[mes - 1];
    c._ano = ano;
    c._semana = this.SEMANA_CURTO[semana];
    c._dataCompleta = c._dia + '/' + (mes < 10 ? '0' + mes : mes) + '/' + ano;
    c._acessivel = this.SEMANA[semana] + ', ' + dia + ' de ' + this.MESES[mes - 1] + ' de ' + ano;

    if (dias < 0) {
      c._estado = 'atrasado';
      const n = Math.abs(dias);
      c._selo = n === 1 ? 'ATRASADO 1 DIA' : 'ATRASADO ' + n + ' DIAS';
    } else if (dias === 0) {
      c._estado = 'hoje';
      c._selo = 'VENCE HOJE';
    } else {
      c._estado = 'futuro';
      c._selo = dias === 1 ? 'AMANHÃ' : 'EM ' + dias + ' DIAS';
    }

    c._cls = 'postit p-' + c._estado;
    c._giro = 'g' + (Math.abs(Number(c.id)) % 6);

    const cat = this.mapaCategorias[c.idCategoria];
    if (cat) {
      c._catId = Number(c.idCategoria);
      c._catNome = cat.descricao;
      c._catCor = cat.cor;
      c._catIcone = cat.icone;
    } else {
      c._catId = 0;
      c._catNome = 'Sem categoria';
      c._catCor = this.COR_SEM_CATEGORIA;
      c._catIcone = '◽';
    }
    // fita, escudo e ponto do calendário falam a mesma cor: a da categoria
    c._fita = c._catCor;
    c._pontoCor = c._catCor;
    c._delay = '0s';
    return c;
  }

  // =========================================================================
  // FILTROS  (combinaveis: escopo AND periodo AND categoria)
  // =========================================================================

  mudarEscopo(v: string) {
    if (this.escopo === v) { return; }
    this.escopo = v;
    // a busca pertence ao escopo "todos"; sair dele a descarta
    if (v !== 'todos') {
      this.busca = '';
      this.buscaAtiva = '';
    }
    this.marcarFiltro();
    this.consultar(false);
  }

  alternarTempo(chave: string) {
    this.fTempo[chave] = !this.fTempo[chave];
    this.marcarFiltro();
    this.consultar(false);
  }

  alternarCategoria(id: number) {
    this.fCategorias[id] = !this.fCategorias[id];
    this.marcarFiltro();
    this.consultar(false);
  }

  limparFiltros() {
    this.fTempo = { atrasado: false, hoje: false, futuro: false };
    this.fCategorias = {};
    this.busca = '';
    this.buscaAtiva = '';
    this.marcarFiltro();
    this.consultar(false);
  }

  /** Busca acionada explicitamente: só consulta quando o termo de fato muda. */
  buscar() {
    const t = (this.busca || '').trim();
    if (t === this.buscaAtiva) { return; }
    this.buscaAtiva = t;
    this.marcarFiltro();
    this.consultar(false);
  }

  limparBusca() {
    if (!this.busca && !this.buscaAtiva) { return; }
    this.busca = '';
    if (this.buscaAtiva === '') { return; }
    this.buscaAtiva = '';
    this.marcarFiltro();
    this.consultar(false);
  }

  private marcarFiltro() {
    let cAtivo = false;
    const ids = Object.keys(this.fCategorias);
    for (let i = 0; i < ids.length; i++) {
      if (this.fCategorias[ids[i]]) { cAtivo = true; break; }
    }
    this.temFiltro = this.fTempo.atrasado || this.fTempo.hoje || this.fTempo.futuro
      || cAtivo || this.buscaAtiva !== '';
  }

  private definirVazio() {
    if (this.visiveis.length > 0) { return; }
    if (this.contaNova) {
      this.iconeVazio = '👋';
      this.rotuloVazio = 'Bem-vindo! Esta é uma conta nova.';
      this.detalheVazio = 'Ainda não há nenhum compromisso salvo aqui. Crie o primeiro e ele aparecerá neste quadro.';
      return;
    }
    if (this.buscaAtiva) {
      this.iconeVazio = '🔎';
      this.rotuloVazio = 'Nada encontrado para “' + this.buscaAtiva + '”';
      this.detalheVazio = 'Nenhuma descrição contém esse termo com os filtros atuais. Tente outra palavra ou limpe a busca.';
      return;
    }
    if (this.temFiltro) {
      this.iconeVazio = '🧭';
      this.rotuloVazio = 'Nenhum compromisso com esses filtros';
      this.detalheVazio = 'Ajuste os filtros de período ou de categoria para ver mais resultados.';
      return;
    }
    if (this.escopo === 'radar' && this.cont.todos > 0) {
      this.iconeVazio = '🗒️';
      this.rotuloVazio = 'Nada no radar por enquanto';
      this.detalheVazio = 'Você tem ' + this.cont.todos + ' compromisso(s) agendado(s), mas nenhum dentro do prazo de aviso. Toque em "Todos" para ver o quadro completo.';
      return;
    }
    this.iconeVazio = '🎉';
    this.rotuloVazio = 'Tudo em dia';
    this.detalheVazio = 'Não há compromissos pendentes. Aproveite.';
  }

  // =========================================================================
  // COMPROMISSO - criar / editar / clonar
  // =========================================================================

  novoEvento() {
    if (!this.categorias.length) {
      this.dao.toast('e', 'Cadastre ao menos uma categoria antes de criar compromissos');
      this.abrirCategorias();
      return;
    }
    this.evento = {
      visivel: true,
      id: 0,
      titulo: 'Novo compromisso',
      acao: 'Criar compromisso',
      descricao: '',
      dia: this.isoHoje(),
      aviso: 3,
      idCategoria: this.categorias[0].id
    };
    this.atualizarPrevia();
  }

  editar(co: any) {
    this.evento = {
      visivel: true,
      id: co.id,
      titulo: 'Editar compromisso',
      acao: 'Salvar alterações',
      descricao: co.descricao,
      dia: co._iso,
      aviso: Number(co.aviso) || 3,
      idCategoria: co._catId ? co._catId : (this.categorias.length ? this.categorias[0].id : 0)
    };
    this.atualizarPrevia();
  }

  escolherCategoriaEvento(id: any) {
    this.evento.idCategoria = id;
    this.atualizarPrevia();
  }

  escolherAviso(n: number) {
    this.evento.aviso = n;
    this.atualizarPrevia();
  }

  /** Atalhos de data: hoje, amanhã, +7, +30. */
  adiarPara(dias: number) {
    const d = new Date();
    d.setHours(12, 0, 0, 0);
    d.setDate(d.getDate() + dias);
    this.evento.dia = this.iso(d);
    this.atualizarPrevia();
  }

  /** Mantém o post-it de pré-visualização em sincronia com o formulário. */
  atualizarPrevia() {
    const e = this.evento;
    const cat = this.mapaCategorias[e.idCategoria];
    const cor = cat ? cat.cor : this.COR_SEM_CATEGORIA;
    const iso = (e.dia || '').substring(0, 10);
    const p: any = {
      _cls: 'postit p-futuro',
      _fita: cor,
      _catNome: cat ? cat.descricao : 'Sem categoria',
      _catCor: cor,
      _catIcone: cat ? cat.icone : '◽',
      descricao: e.descricao ? e.descricao : 'A descrição do compromisso aparece aqui.',
      _vazia: !e.descricao
    };

    if (iso.length === 10) {
      const partes = iso.split('-');
      const ano = Number(partes[0]);
      const mes = Number(partes[1]);
      const dia = Number(partes[2]);
      const alvo = new Date(ano, mes - 1, dia);
      alvo.setHours(12, 0, 0, 0);
      const hoje = new Date();
      hoje.setHours(12, 0, 0, 0);
      const dias = Math.round((alvo.getTime() - hoje.getTime()) / 86400000);

      p._dia = dia < 10 ? '0' + dia : '' + dia;
      p._mesExt = this.MESES_CURTO[mes - 1];
      p._ano = ano;
      p._semana = this.SEMANA_CURTO[alvo.getDay()];

      if (dias < 0) {
        p._cls = 'postit p-atrasado';
        const n = Math.abs(dias);
        p._selo = n === 1 ? 'ATRASADO 1 DIA' : 'ATRASADO ' + n + ' DIAS';
      } else if (dias === 0) {
        p._cls = 'postit p-hoje';
        p._selo = 'VENCE HOJE';
      } else {
        p._cls = 'postit p-futuro';
        p._selo = dias === 1 ? 'AMANHÃ' : 'EM ' + dias + ' DIAS';
      }
    } else {
      p._dia = '--';
      p._mesExt = '---';
      p._ano = '----';
      p._semana = '---';
      p._selo = 'SEM DATA';
    }
    this.previa = p;
  }

  async salvarEvento() {
    const e = this.evento;
    if (!e.descricao || !(e.descricao + '').trim()) {
      this.dao.toast('e', 'Informe a descrição do compromisso');
      return;
    }
    if (!e.dia) {
      this.dao.toast('e', 'Informe a data do compromisso');
      return;
    }
    if (!e.aviso || Number(e.aviso) < 0) {
      this.dao.toast('e', 'Informe com quantos dias de antecedência quer ser avisado');
      return;
    }
    if (!e.idCategoria) {
      this.dao.toast('e', 'Escolha uma categoria para o compromisso');
      return;
    }

    // a coluna `cor` continua existindo por compatibilidade; espelha a cor da
    // categoria para que dados antigos e novos contem a mesma história
    const cat = this.mapaCategorias[e.idCategoria];
    const dados = {
      id: e.id,
      chave: this.obterChave(),
      dia: e.dia,
      aviso: Number(e.aviso),
      descricao: (e.descricao + '').trim(),
      cor: cat ? cat.cor : this.COR_SEM_CATEGORIA,
      idCategoria: e.idCategoria
    };

    this.loader.start();
    const res = await this.dao.submeterEm(dados, 'salvarCompromisso', this.servidor).catch(() => {
      this.loader.stop();
      this.dao.toast('e', 'Falha ao salvar o compromisso');
    });
    this.loader.stop();
    if (res === 'ok') {
      this.dao.toast('s', e.id ? 'Compromisso atualizado com sucesso!' : 'Compromisso registrado com sucesso!');
      this.evento = { visivel: false };
      this.consultar(true);
    }
  }

  clonar(co: any) {
    this.conf.confirm({
      header: 'Clonagem de compromisso',
      message: 'Criar uma cópia de <strong>' + this.escapar(co.descricao) + '</strong>?'
        + '<br>A cópia nasce com a mesma data, categoria, cor e aviso, e recebe o prefixo <strong>(copia)</strong> na descrição.',
      key: 'agenda',
      acceptLabel: 'CLONAR',
      rejectLabel: 'CANCELAR',
      accept: async () => {
        this.loader.start();
        const r = await this.dao.submeterEm({ id: co.id, chave: this.obterChave() }, 'clonarCompromisso', this.servidor)
          .catch(() => {
            this.loader.stop();
            this.dao.toast('e', 'Falha ao clonar o compromisso');
          });
        this.loader.stop();
        if (r === 'ok') {
          this.dao.toast('s', 'Cópia criada com sucesso!');
          this.consultar(true);
        }
      }
    });
  }

  concluir(co: any) {
    this.conf.confirm({
      header: 'Conclusão de compromisso',
      message: 'Concluir <strong>' + this.escapar(co.descricao) + '</strong>?<br>Ele deixa de ser exibido no quadro, mas continua no histórico do calendário.',
      key: 'agenda',
      acceptLabel: 'CONCLUIR',
      rejectLabel: 'CANCELAR',
      accept: async () => {
        this.loader.start();
        const r = await this.dao.submeterEm(co, 'concluirCompromisso', this.servidor).catch(() => this.loader.stop());
        this.loader.stop();
        if (r === 'ok') {
          this.dao.toast('s', 'Compromisso concluído com sucesso!');
          this.consultar(true);
        }
      }
    });
  }

  excluir(co: any) {
    this.conf.confirm({
      header: 'Exclusão de compromisso',
      message: 'Excluir <strong>' + this.escapar(co.descricao) + '</strong>?<br>Esta ação é permanente e não pode ser desfeita.',
      key: 'agenda',
      acceptLabel: 'EXCLUIR',
      rejectLabel: 'CANCELAR',
      accept: async () => {
        this.loader.start();
        const r = await this.dao.submeterEm(co, 'excluirCompromisso', this.servidor).catch(() => this.loader.stop());
        this.loader.stop();
        if (r === 'ok') {
          this.dao.toast('s', 'Compromisso excluído com sucesso!');
          this.consultar(true);
        }
      }
    });
  }

  reagendar(co: any) {
    this.telaReaj = {
      visivel: true,
      compromisso: co,
      dia: co._iso,
      aviso: Number(co.aviso) || 3
    };
  }

  adiarReagendamento(dias: number) {
    const d = new Date();
    d.setHours(12, 0, 0, 0);
    d.setDate(d.getDate() + dias);
    this.telaReaj.dia = this.iso(d);
  }

  async reagendarCompromisso() {
    if (!this.telaReaj.dia) {
      this.dao.toast('e', 'Informe a nova data');
      return;
    }
    if (!this.telaReaj.aviso) {
      this.dao.toast('e', 'Informe com quantos dias de antecedência quer ser avisado');
      return;
    }
    const dados = {
      id: this.telaReaj.compromisso.id,
      dia: this.telaReaj.dia,
      aviso: Number(this.telaReaj.aviso)
    };
    this.loader.start();
    const r = await this.dao.submeterEm(dados, 'reagendarCompromisso', this.servidor).catch(() => this.loader.stop());
    this.loader.stop();
    if (r === 'ok') {
      this.dao.toast('s', 'Compromisso reagendado com sucesso!');
      this.telaReaj = { visivel: false };
      this.consultar(true);
    }
  }

  // =========================================================================
  // CATEGORIAS - CRUD
  // =========================================================================

  abrirCategorias() {
    this.telaCategorias = { visivel: true };
    this.formCat = { visivel: false };
  }

  novaCategoria() {
    this.formCat = {
      visivel: true,
      id: 0,
      titulo: 'Nova categoria',
      descricao: '',
      cor: this.CORES_RAPIDAS[Math.floor(Math.random() * this.CORES_RAPIDAS.length)],
      icone: '📌'
    };
  }

  editarCategoria(cat: any) {
    this.formCat = {
      visivel: true,
      id: cat.id,
      titulo: 'Editar categoria',
      descricao: cat.descricao,
      cor: cat.cor,
      icone: cat.icone
    };
  }

  escolherCorCategoria(cor: string) {
    this.formCat.cor = cor;
  }

  abrirEmojis() {
    this.seletorEmoji = { visivel: true };
  }

  escolherEmoji(e: string) {
    this.formCat.icone = e;
    this.seletorEmoji = { visivel: false };
  }

  async salvarCategoria() {
    const f = this.formCat;
    if (!f.descricao || !(f.descricao + '').trim()) {
      this.dao.toast('e', 'Informe a descrição da categoria');
      return;
    }
    const dados = {
      id: f.id,
      chave: this.obterChave(),
      descricao: (f.descricao + '').trim(),
      cor: f.cor,
      icone: f.icone
    };
    this.loader.start();
    const r = await this.dao.submeterEm(dados, 'salvarCategoria', this.servidor).catch(() => {
      this.loader.stop();
      this.dao.toast('e', 'Falha ao salvar a categoria');
    });
    this.loader.stop();
    if (!r) { return; }
    if (r['resultado'] === 'duplicada') {
      this.dao.toast('e', 'Já existe uma categoria com essa descrição');
      return;
    }
    this.dao.toast('s', f.id ? 'Categoria atualizada!' : 'Categoria criada!');
    this.formCat = { visivel: false };
    this.aposMudarCategorias(r['categorias']);
  }

  excluirCategoriaConfirm(cat: any) {
    const qtd = this.contCat[cat.id] || 0;
    let msg = 'Excluir a categoria <strong>' + this.escapar(cat.descricao) + '</strong>?';
    if (qtd > 0) {
      msg += '<br>' + qtd + ' compromisso(s) ficarão sem categoria — nenhum será apagado.';
    }
    this.conf.confirm({
      header: 'Exclusão de categoria',
      message: msg,
      key: 'agenda',
      acceptLabel: 'EXCLUIR',
      rejectLabel: 'CANCELAR',
      accept: async () => {
        this.loader.start();
        const r = await this.dao.submeterEm({ id: cat.id, chave: this.obterChave() }, 'excluirCategoria', this.servidor)
          .catch(() => this.loader.stop());
        this.loader.stop();
        if (r && r['resultado'] === 'ok') {
          this.dao.toast('s', 'Categoria excluída!');
          this.aposMudarCategorias(r['categorias']);
        }
      }
    });
  }

  /**
   * Mudou o conjunto de categorias: descarta seleções que deixaram de existir
   * (senão o filtro apontaria para um id morto) e refaz a consulta no banco.
   */
  private aposMudarCategorias(lista: any) {
    this.categorias = lista ? lista : [];
    this.indexarCategorias();

    const vivos: any = {};
    for (let i = 0; i < this.categorias.length; i++) {
      vivos[this.categorias[i].id] = true;
    }
    const selecionados = Object.keys(this.fCategorias);
    for (let i = 0; i < selecionados.length; i++) {
      const id = selecionados[i];
      if (id !== '0' && !vivos[id]) { this.fCategorias[id] = false; }
    }

    this.marcarFiltro();
    this.cacheAno = {};
    this.consultar(false);
  }

  // =========================================================================
  // CALENDARIO DO ANO
  // =========================================================================

  abrirCalendario() {
    const hoje = new Date();
    this.calendario.visivel = true;
    this.diaAberto = null;
    this.carregarAno(hoje.getFullYear());
  }

  fecharCalendario() {
    this.calendario.visivel = false;
    this.diaAberto = null;
  }

  anoAnterior() {
    this.carregarAno(this.calendario.ano - 1);
  }

  anoSeguinte() {
    this.carregarAno(this.calendario.ano + 1);
  }

  anoAtual() {
    this.carregarAno(new Date().getFullYear());
  }

  private carregarAno(ano: number) {
    this.diaAberto = null;
    if (this.cacheAno[ano]) {
      this.calendario.ano = ano;
      this.calendario.meses = this.cacheAno[ano].meses;
      this.calendario.vazio = this.cacheAno[ano].vazio;
      return;
    }
    const dados = {
      chave: this.obterChave(),
      inicio: ano + '-01-01',
      fim: ano + '-12-31'
    };
    this.loader.start();
    this.dao.submeterEm(dados, 'compromissosDoAno', this.servidor).then(r => {
      this.loader.stop();
      const lista = r ? r : [];
      const meses = this.montarAno(ano, lista);
      this.cacheAno[ano] = { meses: meses, vazio: lista.length === 0 };
      this.calendario.ano = ano;
      this.calendario.meses = meses;
      this.calendario.vazio = lista.length === 0;
    }).catch(() => {
      this.loader.stop();
      this.dao.toast('e', 'Não foi possível carregar o calendário');
    });
  }

  /** Monta as 12 grades do ano com tudo pré-calculado (sem lógica no template). */
  private montarAno(ano: number, lista: any[]) {
    const porDia: any = {};
    for (let i = 0; i < lista.length; i++) {
      const c = this.decorarItem(lista[i]);
      c._concluido = !!c.concluido;
      c._clsLista = c._concluido ? 'ev-item feito' : 'ev-item';
      const k = c._iso;
      if (!porDia[k]) { porDia[k] = []; }
      porDia[k].push(c);
    }

    const hojeIso = this.isoHoje();
    const meses = [];

    for (let m = 0; m < 12; m++) {
      const primeiroDiaSemana = new Date(ano, m, 1).getDay();
      const totalDias = new Date(ano, m + 1, 0).getDate();
      const celulas = [];
      let comEvento = 0;

      for (let v = 0; v < primeiroDiaSemana; v++) {
        celulas.push({ vazia: true, cls: 'cel vazia', n: '', pontos: [], extra: '', clicavel: false });
      }

      for (let d = 1; d <= totalDias; d++) {
        const iso = ano + '-' + this.pad(m + 1) + '-' + this.pad(d);
        const itens = porDia[iso] || [];
        const semana = new Date(ano, m, d).getDay();

        let cls = 'cel';
        if (semana === 0 || semana === 6) { cls += ' fds'; }
        if (iso === hojeIso) { cls += ' hoje'; }

        const pontos = [];
        if (itens.length) {
          comEvento++;
          cls += ' tem';
          let pior = 'futuro';
          for (let i = 0; i < itens.length; i++) {
            if (i < 3) { pontos.push({ cor: itens[i]._pontoCor, feito: itens[i]._concluido }); }
            if (!itens[i]._concluido) {
              if (itens[i]._estado === 'atrasado') { pior = 'atrasado'; }
              else if (itens[i]._estado === 'hoje' && pior !== 'atrasado') { pior = 'hoje'; }
            }
          }
          cls += ' t-' + pior;
        }

        celulas.push({
          vazia: false,
          n: d,
          iso: iso,
          cls: cls,
          pontos: pontos,
          extra: itens.length > 3 ? '+' + (itens.length - 3) : '',
          clicavel: itens.length > 0,
          itens: itens,
          titulo: itens.length
            ? d + ' de ' + this.MESES[m] + ' — ' + itens.length + ' compromisso(s)'
            : d + ' de ' + this.MESES[m]
        });
      }

      meses.push({
        nome: this.MESES[m],
        curto: this.MESES_CURTO[m],
        celulas: celulas,
        cls: comEvento ? 'mes' : 'mes apagado',
        resumo: comEvento ? comEvento + ' dia(s) com compromisso' : 'sem compromissos'
      });
    }
    return meses;
  }

  abrirDia(cel: any) {
    if (!cel.clicavel) { return; }
    this.diaAberto = cel;
  }

  fecharDia() {
    this.diaAberto = null;
  }

  // =========================================================================
  // UTILITARIOS
  // =========================================================================

  private pad(n: number) {
    return n < 10 ? '0' + n : '' + n;
  }

  private iso(d: Date) {
    return d.getFullYear() + '-' + this.pad(d.getMonth() + 1) + '-' + this.pad(d.getDate());
  }

  private isoHoje() {
    return this.iso(new Date());
  }

  private escapar(t: any) {
    return (t + '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  /** Decide texto claro ou escuro sobre a cor da categoria (contraste WCAG). */
  private contraste(hex: string) {
    const h = (hex || '#000000').replace('#', '');
    if (h.length < 6) { return '#ffffff'; }
    const r = parseInt(h.substring(0, 2), 16);
    const g = parseInt(h.substring(2, 4), 16);
    const b = parseInt(h.substring(4, 6), 16);
    const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return lum > 0.6 ? '#1f2430' : '#ffffff';
  }

  /** trackBy: preserva os nós do DOM entre reordenações do calendário. */
  porId(i: number, item: any) {
    return item.id;
  }

  porIndice(i: number) {
    return i;
  }
}
